import Alpine from "alpinejs";
import filter, { Filters } from "../../Organism/Filter/Filter";

Alpine.data("PeopleGrid", (filters: Filters) => ({
    ...filter(filters),
    selected: null,
    init() {
        Alpine.bind(this.$root, this.root);
        this.initFilter();
        const teaser = this.$el.querySelector("[data-id=teaser]");

        this.filterContainer().replaceChildren(...[...this.filterContainer().children].sort(() => Math.random() - 0.5));

        this.filterContainer().insertBefore(teaser, this.filterContainer().childNodes.item(2).nextSibling);
    },
    root: {
        ["x-on:filterchange"]() {
            this.filterContainer().scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
        },
    },
}));
